import type { Schema } from '../../amplify/data/resource'
import { generateClient } from 'aws-amplify/data'

interface Projeto {
    id: string,
    nome: string
}

const client = generateClient<Schema>()

const transformProjetoData = (data: any): Projeto => {
    return {
        id: data?.id ?? '',
        nome: data?.nome ?? ''
    }
}

const getProjetos = async (): Promise<any[]> => {
    try {
        const { data, errors } = await client.models.tbProjetosITEMM.list();

        if (errors) {
            throw new Error(`Failed to get projetos: ${errors.map(e => e.message).join(', ')}`);
        }

        return data;
    } catch (error) {
        console.error('Erro ao buscar projetos:', error);
        throw new Error('Failed to get projetos');
    }
};


const createProjeto = async (projeto: any) => {
    await client.models.tbProjetosITEMM.create(projeto)
}


const updateProjeto = async (projeto: Projeto): Promise<Projeto> => {
    try {
        const projetoAtualizado = {
            ...projeto
        }

        const { data, errors } = await client.models.tbProjetosITEMM.update(projetoAtualizado)

        if (errors) {
            throw new Error(`Failed to update Projeto: ${errors.map(e => e.message)}`)
        }

        const updatedProjeto = transformProjetoData(data)

        return updatedProjeto
    } catch (error) {
        console.error('Erro ao atualizar projeto: ', error)
        throw new Error('Failed to update projeto')
    }
}


const deleteProjeto = async (id: string): Promise<void> => {
    try {
      const { errors } = await client.models.tbProjetosITEMM.delete({ id });
  
      if (errors) {
        throw new Error(`Failed to delete Projeto: ${errors.map(e => e.message).join(', ')}`);
      }
  
      //console.log(`Projeto com ID: ${id} foi deletado com sucesso.`);
    } catch (error) {
      console.error('Erro ao deletar projeto:', error);
      throw new Error('Failed to delete projeto');
    }
  };


export { getProjetos, createProjeto, updateProjeto, deleteProjeto }
export type { Projeto }